<template>
	<div class="noticeScrollX">
		<div class="notice-container-x center-wrap" ref="container">
			<div class="notice-wrapper-x" ref="wrapper">
				<div class="notice-list-x" :style="{ transform: `translateX(-${scrollX}px)` }" @mouseenter="stopScroll"
					@mouseleave="startScroll">
					<span v-for="(item, index) in duplicatedNotices" :key="index" class="notice-item-x txt-16">
						{{ item.id }}
						<span style="padding: 0 4px;">{{ item.symbol }}</span>
						{{ item.price }}
						<span style="padding:0 4px;" :style="{ color: item.price_zf > 0 ? '#00f0ff' : '#ff341f' }">({{
							item.price_zf }})</span>
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "NoticeScrollX",
	props: {
		// notices: {
		// 	type: Array,
		// 	default: () => [],
		// },
		speed: {
			type: Number,
			default: 1, // 滚动速度，越大越快
		},
	},
	data() {
		return {
			scrollX: 0,
			wrapperWidth: 0,
			listWidth: 0,
			timer: null,

			notices: [],
		};
	},
	computed: {
		// 复制一份公告，保证循环无缝衔接
		duplicatedNotices() {
			return [...this.notices, ...this.notices];
		},
	},
	mounted() {
		// this.$nextTick(() => {
		// 	this.wrapperWidth = this.$refs.wrapper.offsetWidth;
		// 	this.listWidth = this.$refs.wrapper.querySelector(".notice-list-x").scrollWidth;
		// 	this.startScroll();
		// });
	},
	beforeDestroy() {
		this.stopScroll();
	},
	methods: {
		init(priceData) {
			this.notices = priceData
			this.$nextTick(() => {
				this.wrapperWidth = this.$refs.wrapper.offsetWidth;
				this.listWidth = this.$refs.wrapper.querySelector(".notice-list-x").scrollWidth;
				this.startScroll();
			});
		},
		startScroll() {
			if (this.timer || this.notices.length === 0) return;
			this.timer = setInterval(() => {
				this.scrollX += this.speed;
				if (this.scrollX >= this.listWidth / 2) {
					this.scrollX = 0; // 重置，实现无缝循环
				}
			}, 42); // 约 24fps
		},
		stopScroll() {
			if (this.timer) {
				clearInterval(this.timer);
				this.timer = null;
			}
		},
	},
};
</script>

<style scoped>
.noticeScrollX {
	border-top: 1px solid #2c2c3e;
	border-bottom: 1px solid #2c2c3e;
	background: #0f0f16;
}

.notice-container-x {
	display: flex;
	align-items: center;
	height: 46px;
	overflow: hidden;
	/* background: #fdf6ec;
		border: 1px solid #faecd8; */
	/*  border-radius: 4px; */
	/* padding: 0 10px; */
	white-space: nowrap;
}

.notice-icon {
	margin-right: 8px;
	color: #e6a23c;
	font-size: 18px;
}

.notice-wrapper-x {
	flex: 1;
	overflow: hidden;
}

.notice-list-x {
	display: inline-block;
	white-space: nowrap;
	transition: transform 0.05s linear;
}

.notice-item-x {
	display: inline-block;
	margin-right: 60px;
	/* color: #666; */
	cursor: pointer;
}
</style>